import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSpecialOffersSelector } from '../redux/reducers/app/configuration';
import { isLoggedInSelector } from '../redux/reducers/app/params';
import useBonusAvailabilityParams from './useBonusAvailabilityParams';

export const useNavigationParams = () => {
  const bonusAvailabilityParams = useBonusAvailabilityParams();
  const hasSpecialOffers = useSelector(useSpecialOffersSelector);
  const isLoggedIn = useSelector(isLoggedInSelector);

  return useMemo(
    () => ({
      hasSpecialOffers,
      isLoggedIn,
      ...bonusAvailabilityParams,
    }),
    [bonusAvailabilityParams, hasSpecialOffers, isLoggedIn]
  );
};

export default useNavigationParams;
